<template>
    <div class="highlight-box">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'HighlightBox'
    };
</script>

<style lang="scss" scoped>
    .highlight-box {
        background-color: #EFF1F3;
        border-radius: 12px;
        padding: 16px;

        p,
        span {
            font-size: 14px;
            color: #2F363E;
            font-weight: 500;
            padding: 0;
            margin: 0;
        }
    }
</style>